import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { tap } from "rxjs/operators";

import { Observable } from 'rxjs';

import { CurrentUser } from '../models/current-user.model';
import { AuthService } from './auth.service';
import { UtilityService } from '@ksm-core/shared/services/utility.service';

@Injectable({
  providedIn: "root",
})
export class UserDetailsResolverService  {
  constructor(
    public authService: AuthService,
    private utilityService: UtilityService
  ) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<CurrentUser> | Promise<CurrentUser> | CurrentUser {
    return this.authService.getCurrentUserDetails().pipe(
      tap((response) => {
        response.email= this.utilityService.decryptText(response.email)
        response.contact=this.utilityService.decryptText(response.contact)       
      })
    );
  }
}
